module.exports = __webpack_public_path__ + "img/logo.51a5851c.png";